export default "__VITE_ASSET__B0E9PLls__"